import { ContentTag, provideComponent } from "scrivito"

import { GridWidgetClass } from "./GridWidgetClass"
import "./styles/_grid-widget.scss"

provideComponent(GridWidgetClass, ({ widget }) => {
  return (
    <ContentTag
      className="grid-widget"
      tag="div"
      content={widget}
      attribute="items"
    />
  )
})
